import React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Backdrop as BackdropStyles } from '@airbus/elements/elements'
import { createUseStyles } from '../../lib/styling'

const useStyles = createUseStyles(BackdropStyles, 'backdrop')

type Props = {
  /** If true, the backdrop will show up */
  open?: boolean
  onClick?: React.ReactEventHandler
  transitionDuration?: number
}
export type BackdropProps = Props

export const Backdrop = React.forwardRef<HTMLDivElement, BackdropProps>(
  ({ open, onClick, transitionDuration }, ref) => {
    const classes = useStyles()
    if (!transitionDuration && open) {
      return <div aria-hidden ref={ref} className={classes.root} onMouseDown={onClick} />
    }
    return (
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: transitionDuration }}
            aria-hidden
            ref={ref}
            className={classes.root}
            onClick={onClick}
          />
        )}
      </AnimatePresence>
    )
  },
)

export default Backdrop
